import React from 'react'

import Notification from 'app/ProfileRevampPage/components/Notification'
import PelatihanMandiriSection from 'app/ProfileRevampPage/components/SectionKarya/PelatihanMandiri'
import BuktiKaryaSection from 'app/ProfileRevampPage/components/SectionKarya/BuktiKarya'
import CeritaPraktikSection from 'app/ProfileRevampPage/components/SectionKarya/CeritaPraktik'
import PerangkatAjarSection from 'app/ProfileRevampPage/components/SectionKarya/PerangkatAjar'
import { EmptyStateWithAction } from 'app/ProfileRevampPage/components/EmptyState'
import { useLayoutState } from 'app/ProfileRevampPage/hooks/useLayoutState'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { useProfileDesktopView } from 'app/ProfileRevampPage/hooks/useProfileDesktopView'

const SectionKarya = () => {
  const { isDesktop } = useProfileDesktopView()
  const { isCurrentUser } = useProfile()
  const {
    showPelatihanMandiriSection,
    showBuktiKaryaSection,
    showCeritaPraktikSection,
    showPerangkatAjarSection,
    isProfileKaryaEmpty,
  } = useLayoutState()

  return (
    <>
      {isCurrentUser ? (
        <Notification
          className={isDesktop ? 'bg-surface-subdued' : undefined}
          data-testid="profile-notification-self-view"
        >
          Rekan guru Anda bisa melihat semua informasi di bawah, kecuali Karya
          yang belum terisi.
        </Notification>
      ) : null}

      {isProfileKaryaEmpty ? (
        <EmptyStateWithAction
          data-testid="profile-empty-state-karya"
          className="m-4 p-4 bg-surface-neutral-subdued rounded-[4px]"
          title="Ajak guru ini pakai RGTK, yuk"
          description="RGTK bisa membantu guru mengajar, mengembangkan kompetensi, dan berkarya lebih baik lagi."
        />
      ) : (
        <div className="lg:bg-white lg:p-6 lg:space-y-6">
          {showPelatihanMandiriSection && (
            <PelatihanMandiriSection data-testid="profile-pelatihan-mandiri-section" />
          )}
          {showBuktiKaryaSection && (
            <BuktiKaryaSection data-testid="profile-bukti-karya-section" />
          )}
          {showCeritaPraktikSection && (
            <CeritaPraktikSection data-testid="profile-cerita-praktik-section" />
          )}
          {showPerangkatAjarSection && (
            <PerangkatAjarSection data-testid="profile-perangkat-ajar-section" />
          )}
        </div>
      )}
    </>
  )
}

export default SectionKarya
